export const isMenuToggled = state => state.menuToggled; //eslint-disable-line
export const isPo = state => state.isPo; //eslint-disable-line
export const isPayments = state => state.isPayments; //eslint-disable-line
export const isReceivable = state => state.isReceivables; //eslint-disable-line
export const isPOFirstLoad = state => state.isPOFirstLoad; //eslint-disable-line
export const isPaymentsFirstLoad = state => state.isPaymentsFirstLoad; //eslint-disable-line
export const isReceivablesFirstLoad = state => state.isReceivablesFirstLoad; //eslint-disable-line
export const isZeenow = state => state.isZeenow;



// WEBPACK FOOTER //
// ./src/store/getters.js